module.exports = __webpack_public_path__ + "img/Menu.46eb96af.svg";